import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AgeVerification from '@/components/feature/AgeVerification';
import CategoryCard from '@/components/feature/CategoryCard';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { faqItems } from '@/mocks/faq';

const heroImageUrl = 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20library%20with%20towering%20bookshelves%20filled%20with%20ancient%20manga%20volumes%2C%20warm%20golden%20spotlight%20illuminating%20an%20open%20illustrated%20book%2C%20atmospheric%20dust%20particles%20floating%20in%20light%20beams%2C%20rich%20wood%20and%20leather%20textures%2C%20cinematic%20lighting%2C%20scholarly%20yet%20dramatic%20ambiance%2C%20fine%20art%20photography%20style&width=1600&height=900&seq=hero-manga-01&orientation=landscape';

const featuredArticles = articles.filter((a) => a.featured);

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '成人漫画精选推荐',
    url: 'https://example.com',
    description: '探索成人漫画的多元风格与创作类型，专业内容导航与平台推荐',
    inLanguage: 'zh-Hans',
  };

  return (
    <>
      <AgeVerification />
      <Navbar />

      <main>
        <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
          <img
            src={heroImageUrl}
            alt="成人漫画精选推荐 - 高质量内容平台导航"
            title="成人漫画精选推荐"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50/90"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4 w-full max-w-4xl">
              <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-500 text-sm font-medium mb-6">
                <i className="ri-shield-check-line"></i>
                18+ 成人内容 · 合规导航
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-950 mb-4 leading-tight">
                成人漫画精选推荐
              </h1>
              <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
                探索成人漫画的多元风格与创作类型，为18岁以上成熟读者提供专业内容导航、风格解析与平台推荐，内容分级清晰，安全合规浏览。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/josei-romance"
                  className="px-8 py-3 rounded-md bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览分类
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <Link
                  to="/article/adult-manga-guide-beginner"
                  className="px-8 py-3 rounded-md bg-background-100/80 border border-background-300/60 text-foreground-700 font-medium text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  入门指南
                  <i className="ri-book-open-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                漫画风格分类
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
                八大核心分类，涵盖成人漫画全类型，助你快速定位感兴趣的内容方向
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categories.map((cat) => (
                <CategoryCard key={cat.slug} category={cat} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                  精选推荐文章
                </h2>
                <p className="text-sm md:text-base text-foreground-500">
                  编辑团队精心挑选的深度内容，助你深入了解成人漫画世界
                </p>
              </div>
              <Link
                to="/category/josei-romance"
                className="mt-3 sm:mt-0 inline-flex items-center gap-1 text-sm text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                关于成人漫画阅读的常见疑问与解答
              </p>
            </div>
            <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <details key={index} className="group bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/30 transition-colors">
                    <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.question}</h3>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="relative py-20 md:py-24 px-4 md:px-6 overflow-hidden">
          <div className="absolute inset-0 bg-background-100"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-accent-500/5 via-transparent to-primary-500/5"></div>
          <div className="relative max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
              开启你的成人漫画探索之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
              无论你是初次接触还是资深读者，这里都有适合你的内容导航与深度指南。支持正版，安全阅读，让我们一起探索成人漫画的多元世界。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/josei-romance"
                className="px-8 py-3 rounded-md bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始浏览
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 rounded-md bg-background-200/70 text-foreground-700 font-medium text-sm hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>
      </main>

      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>

      <Footer />
    </>
  );
}